import { render, staticRenderFns } from "./SettingsCampaignConfigView.vue?vue&type=template&id=8aae84fc&scoped=true&"
import script from "./SettingsCampaignConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsCampaignConfigView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCampaignConfigView.vue?vue&type=style&index=0&id=8aae84fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aae84fc",
  null
  
)

export default component.exports